import React from 'react'
import { View, Text, StyleSheet } from 'react-native'
import {
  BG_STYLES,
  Button,
  COLORS,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'

import {
  DIMENSION_HEIGHT,
  DIMENSION_WIDTH,
  isMobileDevice,
} from 'app/utils/common'
import { SowingRecord } from '../../models/crop'
import { CenterModal } from 'app/components/reusable/CenterModal'
import RoundTickIcon from '../../icons/RoundTick'
import RecordRow from './RecordRow'
import RoundImageWithName from 'app/components/reusable/RoundImageWithName'

interface Props {
  isVisible: boolean
  handleClose: () => void
  record: SowingRecord | null
}

const SowingRecordSuccessModal = ({
  isVisible,
  handleClose,
  record,
}: Props) => {
  return (
    <CenterModal
      isVisible={isVisible}
      onClose={handleClose}
      style={{
        width: Math.min(DIMENSION_WIDTH - 32, 576),
        height: Math.min(DIMENSION_HEIGHT - 32, 588),
      }}
    >
      <View
        style={[
          COMMON_STYLES.fullWidth,
          COMMON_STYLES.fullHeight,
          COMMON_STYLES['mt1/2'],
        ]}
      >
        <View
          style={[
            COMMON_STYLES.p1,
            COMMON_STYLES.alignItemsCenter,
            BG_STYLES.bgOlive20,
            COMMON_STYLES.br1,
            COMMON_STYLES.mb1,
          ]}
        >
          <RoundTickIcon />
          <Text
            style={[
              TYPOGRAPHY.TEXT1,
              VARIANTS_STYLES.SEMI_EMPHASIZED,
              TEXT_STYLES.textPrimary100,
              COMMON_STYLES['mt3/4'],
            ]}
          >
            Crop Added Successfully
          </Text>
        </View>
        <View
          style={[
            COMMON_STYLES.pv2,
            COMMON_STYLES.ph2,
            COMMON_STYLES.alignItemsCenter,
            BG_STYLES.bgNeutral00,
            COMMON_STYLES.br1,
            COMMON_STYLES['mv1/2'],
            COMMON_STYLES.flex1,
            COMMON_STYLES.row,
            COMMON_STYLES.alignItemsCenter,
            styles.cardHeight,
          ]}
        >
          <RoundImageWithName
            name={record?.crop.name || ''}
            imgUrl={record?.crop.image_url || ''}
            handleItemClick={() => {
              // do nothing..
              return
            }}
            imageStyle={styles.img100X100}
          />

          <View style={[COMMON_STYLES.flex1, COMMON_STYLES.ml2]}>
            <RecordRow
              label={'Crop'}
              value={record?.crop.name}
              labelColumnWidth={isMobileDevice() ? 60 : 75}
            />

            <RecordRow
              label={'DOS'}
              value={record?.sowing_date}
              labelColumnWidth={isMobileDevice() ? 60 : 75}
            />
            <RecordRow
              label={'Farm'}
              value={record?.farm_name}
              labelColumnWidth={isMobileDevice() ? 60 : 75}
            />
          </View>
        </View>
        <Button
          onClick={handleClose}
          text={'Okay'}
          buttonStyle={[COMMON_STYLES['mv1/2'], styles.h56]}
        />
      </View>
    </CenterModal>
  )
}

const styles = StyleSheet.create({
  h56: {
    height: 56,
  },
  img100X100: {
    height: 100,
    width: 100,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: COLORS.neutral20,
    backgroundColor: COLORS.white,
  },
  cardHeight: {
    height: 244,
  },
})

export default SowingRecordSuccessModal
